class URLS {
    BASE_URL = process.env.REACT_APP_API_BASE_URL || this.getDefaultBaseUrl()
    FOODS = `/api/foods`
    FEEDBACK = `/api/review`
    CONTACTS = `/api/contacts`
    MENU = `/api/categories`
    ALLDATAES = `/api/menu`

    getDefaultBaseUrl() {
        if (typeof window === "undefined") {
            return "http://127.0.0.1:8000"
        }

        const { hostname, origin } = window.location
        const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1"
        const isLanHost = hostname.startsWith("192.168.") || hostname.startsWith("10.") || hostname.startsWith("172.")

        return isLocalhost || isLanHost ? `http://${hostname}:8000` : origin
    }
}

export const PAGES_URLS = new URLS() 
